import { render, staticRenderFns } from "./HomepageList.vue?vue&type=template&id=63dccaf6"
import script from "./HomepageList.vue?vue&type=script&lang=js"
export * from "./HomepageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports